// Client-side download helpers.

function download(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function exportJSON(cases, name = "pursue_cases") {
  const blob = new Blob([JSON.stringify(cases, null, 2)], {
    type: "application/json",
  });
  download(blob, `${name}_${stamp()}.json`);
}

export function exportCSV(cases, name = "pursue_cases") {
  if (!cases?.length) return;
  const cols = [
    "case_id",
    "agency",
    "incident_date",
    "release_date",
    "location",
    "country",
    "lat",
    "lng",
    "type",
    "classification",
    "sensor",
    "duration_minutes",
    "description",
    "source_url",
  ];
  const escape = (v) => {
    if (v == null) return "";
    const s = String(v).replace(/"/g, '""');
    return `"${s}"`;
  };
  const header = cols.join(",");
  const body = cases.map((c) => cols.map((k) => escape(c[k])).join(",")).join("\n");
  const blob = new Blob([header + "\n" + body], { type: "text/csv;charset=utf-8" });
  download(blob, `${name}_${stamp()}.csv`);
}

function stamp() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}
